import { useEffect, useContext, useCallback } from "react";

import StepsPagination from "../Content/StepsPagination";
import StepsHeadline from "../Content/StepsHeadline";
import StepsForm from "../Content/StepsForm";
import RadioImageCard from "../Content/RadioImageCard";
import HelperText from "../Content/HelperText";

import CalculatorContext from "../../Context/CalculatorContext";

import energySourceIcon1 from "../../Images/fuel-type/fuel-type-1.svg";
import energySourceIcon2 from "../../Images/fuel-type/fuel-type-2.svg";
import energySourceIcon3 from "../../Images/fuel-type/fuel-type-3.svg";
import energySourceIcon4 from "../../Images/fuel-type/fuel-type-4.svg";

/* eslint-disable max-len */
function StepTwoPage() {
  const { setCurrentStepIndex, energySource, setEnergySource } = useContext(CalculatorContext);

  useEffect(() => {
    setCurrentStepIndex(1);
  }, [setCurrentStepIndex]);

  const onEnergySourceChange = useCallback(
    (e) => {
      setEnergySource(e.target.value);
    },
    [setEnergySource],
  );

  return (
    <div className="tx-kalo form-steps-abwizard form-steps-abwizard-transparent-md">
      <div className="frame frame-size-default frame-full frame-background-tertiary">
        <div className="frame-group-container">
          <div className="frame-container frame-container-default">
            <div className="frame-inner frame-inner-space-before-extra-small frame-inner-space-after-medium">
              <StepsPagination />

              <StepsHeadline>
                <h4 className="element-header text-center">
                  Bitte wählen Sie die{" "}
                  <span className="text-primary">Energiequelle Ihrer Liegenschaft</span> aus.
                </h4>
              </StepsHeadline>

              <div className="frame frame-size-default frame-indent-8 frame-space-after-extra-small">
                <div className="frame-container frame-container-default">
                  <div className="frame-inner">
                    <div className="tx-powermail">
                      <div className="wrap-fluid">
                        <StepsForm>
                          <fieldset className="powermail_fieldset">
                            <div className="row justify-content-center">
                              <div className="col-lg-12 text-center">
                                <fieldset className="form-group">
                                  <div className="form-group">
                                    <div className="form-group-custom-image-radio">
                                      <div className="row">
                                        <div className="col-md-3">
                                          <RadioImageCard
                                            id="energy_source_1"
                                            image={energySourceIcon1}
                                            label="Erdgas"
                                            value="Erdgas"
                                            checked={energySource === "Erdgas"}
                                            onChange={onEnergySourceChange}
                                          />
                                        </div>

                                        <div className="col-md-3">
                                          <RadioImageCard
                                            id="energy_source_2"
                                            image={energySourceIcon2}
                                            label="Flüssiggas"
                                            value="Flüssiggas"
                                            checked={energySource === "Flüssiggas"}
                                            onChange={onEnergySourceChange}
                                          />
                                        </div>

                                        <div className="col-md-3">
                                          <RadioImageCard
                                            id="energy_source_3"
                                            image={energySourceIcon3}
                                            label="Heizöl"
                                            value="Heizöl"
                                            checked={energySource === "Heizöl"}
                                            onChange={onEnergySourceChange}
                                          />
                                        </div>

                                        <div className="col-md-3">
                                          <RadioImageCard
                                            id="energy_source_4"
                                            image={energySourceIcon4}
                                            label="Fernwärme"
                                            value="Fernwärme"
                                            checked={energySource === "Fernwärme"}
                                            onChange={onEnergySourceChange}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </fieldset>

                                <div className="form-group pt-4 pt-md-3">
                                  <input
                                    className="btn btn-secondary"
                                    type="submit"
                                    value="Weiter"
                                    disabled={energySource === ""}
                                  />
                                </div>
                              </div>
                            </div>
                          </fieldset>
                        </StepsForm>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <HelperText>
                <p>
                  Um die CO<sub>2</sub>-Kosten Ihrer Liegenschaft zu berechnen, benötigen wir
                  Angaben zum Brennstoffbedarf Ihrer Heizanlage.
                </p>

                <p>
                  Die Standardemissionswerte aus der Verordnung über die Emissionsberichterstattung
                  nach dem Brennstoffemissionshandelsgesetz (EBeV) sind die Grundlage für die
                  folgenden Berechnungen. Die Prognose basiert auf den von Ihnen getätigten Angaben
                  und einigen Annahmen. Sie soll Ihnen einen Überblick über die voraussichtlichen CO
                  <sub>2</sub>-Kosten Ihrer Liegenschaft geben.
                </p>
                <p>Die KALORIMETA GmbH haftet nicht für die Genauigkeit der Ergebnisse.</p>
              </HelperText>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StepTwoPage;
